var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":require("../assets/NewBg.jpg"),"backgound-size":"cover","width":"120rem","height":"61rem","content":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }